import React from "react";

import ExpiredUserListData from "../../../components/userlistdata/expiredusersdata";

const ExpiredUsers = () => {
  return <ExpiredUserListData />;
};

export default ExpiredUsers;
